import React from 'react';
import Select from '@material-ui/core/Select';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import SmsIcon from '@material-ui/icons/Sms';
import SendIcon from '@material-ui/icons/Send';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width:'100%',
    marginBottom:24
  }
}));
const SmsNotificationRender = (props) => {
  const {
    snackbarOpen,
    setSnackbarOpen,
    smsTemplates,
    currentSmsTemplate,
    setSmsTemplateAndContent,
    smsContent,
    sendSms,
    smsIsSending,
  } = props;
  const classes = useStyles();
  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message="Message was sent successfully!"
      />
      {smsTemplates && !!smsTemplates.length && (
        <div>
          {/*<Typography gutterBottom>
            Select an SMS to send the customer from the list of configured SMS
            templates below
          </Typography>*/}
          <br />
          <Box display="flex" justifyContent="space-around" flexWrap="wrap" className="filter_items">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="text-template-sms">Text Template</InputLabel>
              <Select
                labelId="text-template-sms"
                style={{ float: 'left' }}
                className="template-select"
                value={currentSmsTemplate}
                onChange={(e) => setSmsTemplateAndContent(e)}
                label="Text Template"
              >
                {smsTemplates.map(({ filename }) => (
                  <MenuItem key={filename} value={filename}>
                    {
                      smsTemplates.find(
                        (template) => template.filename === filename,
                      ).title
                    }
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box className="communication_checkbox">
            <FormControlLabel
              control={
                <Checkbox
                  checked={'true'}
                  name="sendTo"
                  color="secondary"
                  value="customer"
                />
              }
              className="checked"
              label="Customer"
            />
          </Box>
          {/*<Box>
            <FormControlLabel
              control={
                <Checkbox
                  name="sendTo"
                  color="secondary"
                  value="admin"
                />
              }
              label="Admin"
            />
          </Box>*/}
          <Box>
            {!!smsContent && (
              <span>
                <br />
                <span style={{ color:'#919EAB', marginBottom:4 }}>Text Preview:</span>
                <div style={{color:'#212B36'}}>{smsContent}</div>
              </span>
            )}
            <Button
              color="secondary"
              onClick={(e) => sendSms(e)}
              disabled={smsIsSending}
              variant="contained"
              className="send_btn"
            >
              {smsIsSending ? (
                <>
                  <SendIcon style={{ paddingRight: '0.5em' }} />
                  Your message is on its way!
                </>
              ) : (
                <>
                  Send
                  <svg style={{ paddingLeft: '0.5em' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.925 5.025L9.18333 7.70833L2.91667 6.875L2.925 5.025ZM9.175 12.2917L2.91667 14.975V13.125L9.175 12.2917ZM1.25833 2.5L1.25 8.33333L13.75 10L1.25 11.6667L1.25833 17.5L18.75 10L1.25833 2.5Z" fill="#006C9C"/>
                    <path d="M3.12203 4.56546L2.4284 4.26806L2.42501 5.02275L2.41667 6.87275L2.41469 7.31265L2.85076 7.37064L9.11742 8.20397L9.38037 7.24879L3.12203 4.56546ZM9.37203 12.7512L9.109 11.796L2.85067 12.6294L2.41667 12.6872V13.125V14.975V15.7334L3.1137 15.4345L9.37203 12.7512ZM1.75725 16.7421L1.75063 12.1043L13.8161 10.4956V9.50439L1.75063 7.89566L1.75725 3.25795L17.4812 10L1.75725 16.7421Z" stroke="#00B8D9" stroke-opacity="0.16"/>
                  </svg>
                </>
              )}
            </Button>
          </Box>
        </div>
      )}
      <br />
    </div>
  );
};

export default SmsNotificationRender;
